<template>
  <div class="training-school">
    <div class="training-school-inner">
      <div class="training-school-head">
        <img src="@/assets/newIndex/u30929.png" />
        <ul class="training-schoolul">
          <li class="training-school-headtext active">重点专题学习</li>
        </ul>
      </div>
      <!-- 渐变线条 -->
      <div class="gitern"></div>
      <div class="trainingvideo">
        <div class="trainingvideright">
          <div
            class="trainingimgli"
            v-for="(item,index) in QuestionList"
            :key="index"
            @click="newsVideo(item.id)"
            v-if="index<8"
          >
            <img :src="item.imgUrl" />
            <div class="video-box-footer">
              <div class="traingimgtext onele">{{item.name}}</div>

              <div
                class="traingimgtext"
                style="font-size:14px;color:#888"
                v-if="item.source"
              >来源：{{item.source}}</div>
              <div class="micrGs">{{item.des}}</div>
            </div>
          </div>
          <div style="flex:1;" v-if="QuestionList.length > 0"></div>
          <nodata v-if="QuestionList.length==0" style="margin: 0 auto; margin-top: 100px;"></nodata>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as studyClassIndex from '@/api/studyClass/index';
import treeSelectt from '@/components/treeSelectt'; //文本框选中部门树形结构异步加载
import elSelectc from '@/components/elSelect';
import * as resourceInfo from '@/api/resources/index.js';
import * as diss from '@/api/studyClass/disstation.js';
export default {
  components: {
    treeSelectt,
    elSelectc,
  },
  data() {
    return {
      QuestionList: [],
      specialId: 0,
      tabActive: 0,
      listQuery: {
        title: '',
        address: null,
        deptId: 0,
        JzId: null,
      },
      tablist: [],
      sid: +new Date(),
    };
  },
  mounted() {
    // this.GetDocHotWkName();
    this.getdissList();
  },
  methods: {
    // 更多
    acadMore() {
      this.$router.push('/mooc/policeAcademyMore');
    },
    // 重点专题学习
    getdissList() {
      let listQuerys = {
        isHot: true,
        status: 1,
      };
      diss.MoocSpecialLoad(listQuerys).then((res) => {
        this.QuestionList = res.data;
      });
    },
    // 或者重点学习头部
    GetDocHotWkName() {
      let data = {};
      studyClassIndex.GetDocHotWkName(data).then((res) => {
        this.tablist = res.result;
        this.specialId = this.tablist[0].id;
        this.MoocQuestionList();
      });
    },

    //跳转到新页面进入视频的播放
    newsVideo(id) {
      // resourceInfo.DocumentRead(id).then((res) => {});
      // this.$router.push('/sourceslist/videoLearn?id=' + id);

      this.$router.push({
        path: '/mooc/disstations',
        query: {
          id: id,
        },
      });
    },
    tabHandleChange(index, id) {
      this.tabActive = index;
      this.specialId = id;
      this.$emit('tabChange', this.tabActive);
      this.MoocQuestionList();
    },
  },
};
</script>

<style lang="scss" scoped>
.training-school {
  margin: 14px 0;
  .training-school-inner {
    width: 1200px;
    box-sizing: border-box;
    padding: 31px 20px 9px 20px;
    margin: 0 auto;
    border-radius: 4px;
    background-color: #fff;
    .training-school-head {
      width: 100%;
      padding-bottom: 11px;
      display: flex;
      align-items: center;
      &>img{
        height: auto;
        width: 29px;
        margin-right: 11px;
      }
      @include themeify {
        border-color: themed('color-border-base');
      }
      .training-schoolul {
        .training-school-headtext {
          font-size: 16px;
          font-weight: 700;
          line-height: 24px;
          @include themeify {
            color: themed('color-text-secondary');
            border-color: themed('color-border-base');
          }
          &.active {
            @include themeify {
              color: #000;
              border-bottom-color: themed('color-background-base');
            }
          }
        }
      }
    }
    .trainingvideo {
      padding-top: 27px;
      .trainingvideright {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        .trainingimgli {
          margin-right: 16px;
          margin-bottom: 27px;
          width: 278px;
          box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
          cursor: pointer;
          box-sizing: border-box;
          &:hover {
            box-shadow: 2px 2px 6px rgb(242 242 242 / 99%);
            transform: scale(1.02);
          }
          img {
            width: calc(100% - 8px);
            height: 157px;
            border-radius: 2px;
            margin: 6px 4px 0px 4px;
          }
          .traingimgtext {
            font-size: 16px;
            line-height: 24px;
            color: rgb(39, 38, 54);
          }
          .video-box-footer {
            padding: 0px 8px;
          }
          .traingimgnametxtlil {
            color: #999;
            font-size: 14px;
            display: flex;
            padding-bottom: 10px;
            padding-left: 10px;
            .traingimgname {
              padding: 3px 5px;
              color: #fff;
              background-color: #4876c4;
              border-radius: 4px;
              font-size: 13px;
              margin-right: 8px;
            }
            .traniBox {
              display: flex;
              padding-right: 5px;
              .trainicon {
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 12px;
                img {
                  width: 20px;
                  height: 20px;
                  margin-right: 2px;
                }
              }
            }
          }
        }
        .trainingimgli:nth-child(4n){
          margin-right: 0px;
        }
      }
    }
  }
}

.gdbox {
  display: flex;
  align-items: center;
  line-height: 50px;
  color: #1492ff;
  padding-right: 10px;

  .gdtext {
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
      color: #1492ff;
    }
  }
  .gdimg {
    margin: 0 10px 0 8px;
  }
}

.play-btn {
  font-size: 50px;
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  &:hover {
    cursor: pointer;
  }
}
.gitern {
  height: 2px;
  width: 100%;
  background: linear-gradient(139deg, #1492ff, #d51919);
}
.search-box {
  width: 1200px;
  border-radius: 5px;
  height: 80px;
  background-color: #5c7dbd;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .select-box {
    display: flex;
    align-items: center;
    .select-title {
      color: white;
      font-weight: 700;
      font-size: 16px;
    }
  }
}
.onele {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.micrGs {
  max-height: 98px;
  margin-bottom: 23px;
  line-height: 18px;
  font-size: 12px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  letter-spacing: 1px;
  color: rgb(102, 102, 102);
}
</style>
